function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.14501 11.6066L13.4518 4.29984C13.582 4.16967 13.793 4.16967 13.9232 4.29984L14.3946 4.77125C14.5248 4.90142 14.5248 5.11247 14.3946 5.24265L6.38072 13.2565C6.25054 13.3867 6.03949 13.3867 5.90931 13.2565L1.66667 9.01389C1.5365 8.88371 1.5365 8.67266 1.66667 8.54248L2.13808 8.07108C2.26825 7.9409 2.47931 7.9409 2.60948 8.07108L6.14501 11.6066Z",
  fill: "#3370FF"
});
var SvgQuestionnaireDone = function SvgQuestionnaireDone(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestionnaireDone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/questionnaire_done.8f806337.svg";
export { ForwardRef as ReactComponent };